<template>
  <question-card
    @submit="submit"
    :disabled="buttonDisabled"
    :buttonText="UIComponentData.Button.Translations[questionnaireLead.Language]"
  >
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}
    </template>
    <div>
      <v-text-field
        autofocus
        outlined
        :label="UIComponentData.InputPlaceholder1.Translations[questionnaireLead.Language]"
        v-model="questionnaireLead.Email"
        @input="$v.questionnaireLead.Email.$touch()"
        ref="input"
        required
      />
    </div>
  </question-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { email, required } from 'vuelidate/lib/validators';
import QuestionCard from '@/components/QuestionCard.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'email-step',
  components: {
    QuestionCard,
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
  },
  mixins: [
    validationMixin,
  ],
  validations: {
    questionnaireLead: {
      Email: {
        required,
        email,
      },
    },
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
    buttonDisabled() {
      return this.$v.$invalid;
    },
  },
  methods: {
    ...mapActions(['mutateLead']),
    async submit() {
      if (!this.$v.$invalid) {
        this.mutateLead(this.questionnaireLead);
        this.$emit('route-to-next-slide',true);
      }
    },
  },
  mounted() {
    this.$refs.input.$el.focus();
  },
};
</script>
